<div class="upload" fxLayout="column">
  <div class="title" fxLayout="row" fxLayoutAlign="space-between end">
    <h1>{{'アップロードファイル一覧（プレゼント用）' | translate}}</h1>

    <div class="basic-button" fxLayoutGap="10px">
      <button mat-raised-button color="warn"  (click)="deleteData()" [disabled]="!selection.selected.length">
        <mat-icon>delete</mat-icon>
        <span>{{'削除' | translate}}</span>
      </button>
    </div>
  </div>

  <div fxLayout="row">
    <div class="supplement">{{'※ユーザーへ配布するプレゼント用画像ファイルを登録します。' | translate}}</div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="dropzone"
      appDropzone
      (hovered)="toggleHover($event)"
      (dropped)="onDrop($event)"
      [class.hovering]="isHovering">

      <div class="body" fxLayout="column">
        <div class="title" fxLayout="row">
          {{'ファイル' | translate}}
          <mat-icon>publish</mat-icon>
        </div>

        <div class="file">
          <input type="file" (change)="onChangeFileInput($event)" multiple>
        </div>
      </div>
    </div>

    <div>
      <mat-form-field fxFlex="250px">
        <mat-label>{{'画像圧縮' | translate}}</mat-label>
        <mat-select [(value)]="compless" (selectionChange)="complessChange($event)" required>
          <mat-option value="1">{{'圧縮する（500KB以下へ）' | translate}}</mat-option>
          <mat-option value="2">{{'圧縮する（640px以下へ）' | translate}}</mat-option>
          <mat-option value="9">{{'圧縮しない' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

</div>

<div *ngFor="let file of files">
  <app-upload-task [file]="file" [compless]="compless" [type]="'DL'"></app-upload-task>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let uploadedFile; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          color="warn"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let uploadedFile">
        <img *ngIf="isImage(uploadedFile)" [src]="uploadedFile.download_url" height="40px" width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let uploadedFile"> {{uploadedFile.file_name}} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'登録日時' | translate}} </th>
      <td mat-cell *matCellDef="let uploadedFile"> {{ uploadedFile.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef> {{'ダウンロード' | translate}} </th>
      <td mat-cell *matCellDef="let uploadedFile">
        <button mat-icon-button color="primary" (click)="downloadFile(uploadedFile)" *ngIf="isImage(uploadedFile)">
          <mat-icon>download</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>
